/**
 * Server API for walkthrough completion preferences.
 * @module features/walkthrough/walkthroughApi
 */
import { apiGet, apiPatch } from '../../utils/api';

/**
 * @returns {Promise<{ success: boolean, data?: { walkthroughCompletedVersion: string | null, walkthroughCompletedAt: string | null } }>}
 */
export async function fetchWalkthroughPreferences() {
  return apiGet('/api/users/me/preferences');
}

/**
 * @param {{ walkthroughCompletedVersion: string, walkthroughCompletedAt: string }} payload
 * @returns {Promise<{ success: boolean, data?: { walkthroughCompletedVersion: string | null, walkthroughCompletedAt: string | null } }>}
 */
export async function patchWalkthroughPreferences(payload) {
  return apiPatch('/api/users/me/preferences', payload);
}
